(() => {
  const start = () => {
    const config = document.getElementById('mox-preorder-labels');
    if (!config) return;
    const labels = JSON.parse(config.textContent);
    const set = (element, value) => {
      if (element && value && element.textContent !== value) element.textContent = value;
    };
    const refresh = () => {
      document.querySelectorAll('.lb-ordereasy-product-list-badge, .lb-ordereasy-product-badge').forEach(badge => set(badge, labels.label));
      document.querySelectorAll('.lb-ordereasy-product-widget').forEach(widget => {
        const scope = widget.closest('.shopify-section') || document;
        const price = scope.querySelector('[data-mox-preorder][data-plan-id="715232051583"]');
        if (!price) return;
        set(widget.querySelector('.lb-ordereasy-widget-title'), labels.payment);
        widget.querySelectorAll('.lb-ordereasy-payment-option').forEach(option => {
          const radio = option.querySelector('input[value="715232051583"]');
          if (!radio) return;
          set(option.querySelector('.lb-ordereasy-payment-option-title'), labels.deposit + ' : ' + price.dataset.deposit);
          set(option.querySelector('.lb-ordereasy-payment-option-description'), price.querySelector('.mox-preorder-price__balance')?.textContent);
          const discount = option.querySelector('.lb-ordereasy-payment-discount');
          const percentage = discount?.textContent.match(/\d+(?:[.,]\d+)?\s*%/)?.[0];
          if (percentage) set(discount, labels.save + ' ' + percentage);
        });
        const terms = [price.querySelector('.mox-preorder-price__total'), price.querySelector('.mox-preorder-price__balance'), price.querySelector('.mox-preorder-price__release')].filter(Boolean).map(e => e.textContent.trim()).join(' ');
        set(widget.querySelector('.lb-ordereasy-purchase-terms'), terms);
        scope.querySelectorAll('.lb-ordereasy-product-badge').forEach(e => set(e,labels.label));
        scope.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(button => {
          if (/précommande|pre.?order/i.test(button.textContent)) set(button, labels.button);
        });
      });
    };
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; refresh(); });
    };
    const selector = '.lb-ordereasy-product-list-badge,.lb-ordereasy-product-badge,.lb-ordereasy-product-widget,[data-mox-preorder]';
    const relevant = node => {
      const element = node instanceof Element ? node : node.parentElement;
      return Boolean(element && (element.closest(selector) || element.querySelector(selector)));
    };
    new MutationObserver(records => {
      if (records.some(record => (record.target instanceof Element ? record.target : record.target.parentElement)?.closest(selector) || Array.from(record.addedNodes).some(relevant))) schedule();
    }).observe(document.body, {subtree:true,childList:true,characterData:true});
    document.addEventListener('change', event => { if (relevant(event.target)) schedule(); });
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
